export const SET_CURRENT_IMAGE_GROUP_IMAGES = "SET_CURRENT_IMAGE_GROUP_IMAGES"
export const SET_UPLOADING_PROGRESS_PERCENTAGE = "SET_UPLOADING_PROGRESS_PERCENTAGE"
export const SET_RESIZING_IMAGES = "SET_RESIZING_IMAGES"
